import pentahoLogService from '@/services/pentahoLog.service';
import commonService from '@/services/common.service';
import config from '@/config/prod.env';

const actions = {
    async getAllPagingPentahoErrorJob({ dispatch }, params) {
        return await pentahoLogService.getAllPagingPentahoErrorJob(params);
    },
    async getAllJobRunIndayPaging({ dispatch }, params) {
        return await pentahoLogService.getAllJobRunIndayPaging(params);
    },
};

export const pentahoLog = {
    namespaced: true,
    actions
};